import Wordmark from "@/components/shared/Wordmark";
import PublicFooter from "@/components/public/PublicFooter";
import Parallax from "@/components/home/Parallax";
import {
  OpenBookDoodle, ClosedBookDoodle, SmallStackDoodle,
  FlyingPagesDoodle, PencilDoodle,
} from "@/components/home/illustrations";
import { cn } from "@/lib/utils";

/**
 * Chrome for the pages families and donors see without signing in:
 * the wordmark, optional book doodles in the desktop margins, the page,
 * and the quiet public footer.
 */
export default function PublicLayout({ children, doodles = false, mainClassName, helpHref }) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-border/60 bg-background/80 backdrop-blur-sm">
        <div className="container flex h-16 items-center justify-center">
          <Wordmark />
        </div>
      </header>

      {doodles && (
        <div className="pointer-events-none fixed inset-0 z-0 hidden lg:block" aria-hidden="true">
          <Parallax speed={0.12} className="absolute left-[3%] top-32 opacity-[0.12]">
            <ClosedBookDoodle size={80} rotate={-12} color="forest" />
          </Parallax>
          <Parallax speed={0.22} className="absolute left-[2%] top-[420px] opacity-[0.10]">
            <PencilDoodle size={70} rotate={28} />
          </Parallax>
          <Parallax speed={0.08} className="absolute right-[3%] top-24 opacity-[0.10]">
            <OpenBookDoodle size={75} rotate={-6} />
          </Parallax>
          <Parallax speed={0.18} className="absolute right-[2%] top-[550px] hidden opacity-[0.08] xl:block">
            <FlyingPagesDoodle size={90} rotate={-10} />
          </Parallax>
          <Parallax speed={0.15} className="absolute left-[4%] top-[850px] hidden opacity-[0.08] xl:block">
            <SmallStackDoodle size={85} rotate={8} />
          </Parallax>
        </div>
      )}

      <main id="main" className={cn("container relative z-10 flex-1", mainClassName)}>{children}</main>
      <PublicFooter helpHref={helpHref} />
    </div>
  );
}
